import React, { useState, useRef, useEffect } from 'react';

// Locations component for NAMHS appointment website
// - This is for the Location Information page (the buttons) on the website
function Locations() {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setSelectedLocation(null);
    }
  };

  useEffect(() => {
    if (selectedLocation) {
      document.addEventListener('mousedown', handleClickOutside);
      // Add keyboard event listener for Escape key
      const handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
          setSelectedLocation(null);
        }
      };
      document.addEventListener('keydown', handleEscapeKey);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscapeKey);
      };
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [selectedLocation]);

  const locations = [
    { 
      name: 'Redding, CA', //Location Checked
      type: 'Clinic',
      address: '1742 Oregon St, Redding, CA 96001',
      phone: '(530) 646-7269',
      hours: 'Monday - Thursday: 8:00 AM - 5:00 PM\nFriday: 8:00 AM - 4:30 PM',
      services: 'Therapy, Psychiatry, Medication Management, Onsite Geenoa Pharmacy',
      doctors: [//Checked
        
        //Medical Providers
        { name: 'Abraham, Robin, PMHNP', specialty: 'Psychiatric Mental Health Nurse Practitioner' },
        { name: 'Evans, Rebecca, PA-C', specialty: 'Physician Assistant' },
        { name: 'Garcia-Cruz, Daniela, PA', specialty: 'Physician Assistant' },
        { name: 'Hongsermeier, Levi, PA-C', specialty: 'Physician Assistant' },
        { name: 'Johnson, Kristine, PMHNP', specialty: 'Psychiatric Mental Health Nurse Practitioner' },
        { name: 'Johnson, Mark, PMHNP', specialty: 'Psychiatric Mental Health Nurse Practitioner' },
        { name: 'Mares, Abelardo, PA-C', specialty: 'Physician Assistant' },
        { name: 'Mueller, Lauren, PA-C', specialty: 'Physician Assistant' },
        { name: 'Deen, Danielle, PA-C', specialty: 'Physician Assistant' },
              
        //Therapy Providers
        { name: 'Barnett, Keith, LCSW', specialty: 'Licensed Clinical Social Worker' },
        { name: 'Jones, Andrea, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Jones, Simeon, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Landaker, Patricia, ACSW', specialty: 'Associate Clinical Social Worker' },
        { name: 'Reynolds, Shawna, LCSW', specialty: 'Licensed Clinical Social Worker' },
      ]
    },
    { 
      name: 'Eureka, CA', //Location Checked
      type: 'Clinic',
      address: '800 West Harris St. Suite #33, Eureka, CA 95503',
      phone: '707-240-4212',
      hours: 'Monday - Thursday: 8:00 AM - 5:00 PM\nFriday: 8:00 AM - 4:30 PM',
      services: 'Psychiatry, Medication Management, Psychotherapy',
      doctors: [ //Checked
        
        //Medical Providers
        { name: 'King, Cristina, PA', specialty: 'Physician Assistant' },
        { name: 'East, Tracy Reine, ACSW', specialty: 'Associate Clinical Social Worker' },
        
        //Therapy Providers
        { name: 'Engber, Natalie, LCSW', specialty: 'Licensed Clinical Social Worker' },
        { name: 'Golly, Jessica, LCSW', specialty: 'Licensed Clinical Social Worker' },
        { name: 'Finn, Mitch, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Torres, Angelina, LCSW', specialty: 'Licensed Clinical Social Worker' },
      ]
    },
    { 
      name: 'Homepsych/Telehealth',
      type: 'Virtual',
      phone: '530-722-4942',
      hours: 'Monday - Thursday: 8:00 AM - 5:00 PM\nFriday: 8:00 AM - 4:30 PM',
      services: 'Talk Therapy, Psychiatry, Medication Management',
      doctors: [ //Checked
        
        //Medical Providers
        { name: 'Alexander, Tianita, PA-C', specialty: 'Physician Assistant' },  
        { name: 'Barnum, Faye, PA-C', specialty: 'Physician Assistant' },
        { name: 'Hull, Candy, PA-C', specialty: 'Physician Assistant' },
        { name: 'Kim, Paul, PA-C', specialty: 'Physician Assistant' },
        { name: 'Michaels, Samuel, PA', specialty: 'Physician Assistant' },
        { name: 'Miller, Jessica, PA', specialty: 'Physician Assistant' },
        { name: 'Mourad, Rola, PA-C', specialty: 'Physician Assistant' },
        { name: 'Samplawski, Olga, PA-C', specialty: 'Physician Assistant' },
        { name: 'Smenkowski, Stephen, PA', specialty: 'Physician Assistant' },
        { name: 'Zakharova, Anastasiya, PA-C', specialty: 'Physician Assistant' },

        //Therapy Providers
        { name: 'Baldwin, Dawnae, AMFT', specialty: 'Associate Marriage & Family Therapist' },
        { name: 'Cuestas, Dominique, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Galaviz, Nikkie, LCSW', specialty: 'Licensed Clinical Social Worker' },
        { name: 'Green, Domonick, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Husa, Stephanie, ACSW', specialty: 'Associate Clinical Social Worker' },
        { name: 'Lane, Victoria, LCSW', specialty: 'Licensed Clinical Social Worker' },
        { name: 'Peck, Kari, LPCC', specialty: 'Licensed Professional Clinical Counselor' },
        { name: 'Rydquist, Alison, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Salazar, Olga, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Sullivan, Tiffany, LMFT', specialty: 'Licensed Marriage & Family Therapist' },

      ]
    },
    { 
      name: 'Red Bluff, CA', //Location Checked
      type: 'Clinic',
      address: '420 S Main Street, Red Bluff, CA 96080',
      phone: '530-999-2014',
      fax: '530-232-5399',
      hours: 'Monday - Thursday: 7:30 AM - 6:30 PM\nFriday: 7:30 AM - 4:30 PM',
      services: 'Therapy, Psychiatry, Medication Management, Bilingual Services',
      doctors: [//Checked
        
        //Medical Providers
        { name: 'Southwell, Rickey, PA-C', specialty: 'Physician Assistant' },
        { name: 'Johnson, Kristine, PMHNP', specialty: 'Psychiatric Mental Health Nurse Practitioner' },

        //Therapy Providers
        { name: 'Sabo, Connie, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
      ]
    },
    { 
      name: 'Fairfield, CA', 
      type: 'Clinic',
      address: '500 Chadbourne Rd Suite B. Fairfield, CA 94534',
      phone: '707-439-4039',
      fax: '530-232-5399',
      hours: 'Monday - Thursday: 7:30 AM - 6:30 PM\nFriday: 7:30 AM - 4:30 PM',
      services: 'Therapy, Psychiatry, Medication Management',
      doctors: [ //Checked
        
        //Medical Providers
        { name: 'Garcia, Taylor, PA-C', specialty: 'Physician Assistant' },
        { name: 'Nguyen, John, PA-C', specialty: 'Physician Assistant' },

        //Therapy Providers
        { name: 'Dover, Carleta Carmela, ACSW', specialty: 'Associate Clinical Social Worker' },
        { name: 'Baldwin, Dawnae, AMFT', specialty: 'Associate Marriage & Family Therapist' },
        { name: 'Miklich, Jeanette, AMFT', specialty: 'Associate Marriage & Family Therapist' },
        { name: 'Snow, Alexander, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
      ]
    },
    { 
      name: 'Hollister, CA', 
      type: 'Clinic',
      address: '901 Sunset Drive Unit #4. Hollister, CA 95023',
      phone: '831-266-4505',
      fax: '831-240-0012',
      hours: '(TBD)',
      services: 'Therapy, Psychiatry, Medication Management',
      doctors: [ //Checked
        { name: 'Bennett, Kelsey, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Southwell, Rickey, PA-C', specialty: 'Physician Assistant' },
        { name: 'Jones, Simeon, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
      ]
    },
    { 
      name: 'Monterey, CA', //Location Checked
      type: 'Clinic',
      address: '1035 Cass St, Monterey, CA 93940',
      phone: '831-886-0002',
      hours: 'Monday - Thursday: 7:30 AM - 6:00 PM\nFriday: 7:30 AM - 4:30 PM',
      services: 'Psychiatry, Medication Management, Psychotherapy',
      doctors: [ //Checked
        
        //Medical Providers
        { name: 'Allen, Everett, PA-C', specialty: 'Physician Assistant' },
        { name: 'Liu, Lian, PMHNP', specialty: 'Psychiatric Mental Health Nurse Practitioner' },
        { name: 'Mares, Abelardo, PA-C', specialty: 'Physician Assistant' },
        { name: 'Wolfe, Justin, PA', specialty: 'Physician Assistant' },

        //Therapy Providers
        { name: 'DuPraw, Stephen, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Harris, Christelle, APCC', specialty: 'Associate Professional Clinical Counselor' },
        { name: 'Lawson, Ann, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Pope, Madalyn, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
      ]
    },
    { 
      name: 'Salinas, CA', 
      type: 'Clinic',
      address: '450 Lincoln Ave Suite 101, Salinas, CA 93901',
      phone: '831-269-5288',
      hours: 'Monday - Thursday: 7:30 AM - 6:00 PM\nFriday: 7:30 AM - 4:30 PM',
      services: 'Therapy, Psychiatry, Medication Management',
      doctors: [//Checked
        
        //Medical Providers
        { name: 'Aguirre-Barthell, Yareli, PA-C', specialty: 'Physician Assistant' },
        { name: 'Medina Chinas, Yanet Alicia, PA-C', specialty: 'Physician Assistant' },
        { name: 'Tran, Andrew, PA-C', specialty: 'Physician Assistant' },
        
        //Therapy Providers
        { name: 'Mendoza, Virginia, ACSW', specialty: 'Associate Clinical Social Worker' },
        { name: 'Solorio, Yeesica, LMFT', specialty: 'Licensed Marriage & Family Therapist' },
        { name: 'Tapia-Medrano, Evelyn, ACSW', specialty: 'Associate Clinical Social Worker' },
        { name: 'Lopez, Maria Guadalupe Diana, LCSW', specialty: 'Licensed Clinical Social Worker' },
      ]
    },
  ].sort((a, b) => a.name.localeCompare(b.name));

  // Service type color mapping
  const serviceColors = {
    'Therapy': 'bg-blue-100 text-blue-700',
    'Psychotherapy': 'bg-blue-100 text-blue-700',
    'Talk Therapy': 'bg-blue-100 text-blue-700',
    'Psychiatry': 'bg-purple-100 text-purple-700',
    'Medication Management': 'bg-green-100 text-green-700',
    'Bilingual Services': 'bg-yellow-100 text-yellow-700',
    'Onsite Geenoa Pharmacy': 'bg-red-100 text-red-700'
  };

  return (
    <section id="locations" className="relative bg-white" style={{ marginTop: '-1px' }}>
      {/* Top wave decoration - different pattern */}
      <div className="relative w-full">
        <svg 
          className="w-full block"
          style={{ height: '100px', display: 'block' }}
          preserveAspectRatio="none"
          viewBox="0 0 1440 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#ffffff"
            d="M0,60 C480,10 960,90 1440,40 L1440,0 L0,0 Z"
          />
        </svg>
      </div>

      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Our Locations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {locations.map((location, index) => (
              <div
                key={index}
                className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                onClick={() => setSelectedLocation(location)}
              >
                <div>
                  <h3 className="text-xl font-semibold text-primary-600 mb-2">
                    {location.name}
                  </h3>
                  <div className="flex flex-wrap gap-1.5">
                    {location.services.split(', ').map((service, index) => (
                      <span 
                        key={index}
                        className={`inline-block px-2 py-0.5 text-xs rounded-full ${serviceColors[service] || 'bg-gray-100 text-gray-700'}`}
                      >
                        {service}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom wave decoration - different pattern */}
      <div className="relative w-full">
        <svg 
          className="w-full block"
          style={{ height: '100px', display: 'block' }}
          preserveAspectRatio="none"
          viewBox="0 0 1440 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#f9fafb"
            d="M0,40 C480,90 960,10 1440,60 L1440,100 L0,100 Z"
          />
        </svg>
      </div>

      {/* Location Details Modal */}
      {selectedLocation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div 
            ref={modalRef}
            className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto"
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-primary-600">
                {selectedLocation.name}
              </h2>
              <button
                onClick={() => setSelectedLocation(null)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Contact Information</h3>
                <div className="space-y-3 text-gray-600">
                  {selectedLocation.address && (
                    <div>
                      <p className="font-semibold">Address:</p>
                      <ul className="list-disc pl-5">
                        <li>
                          <a 
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedLocation.address)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-600 hover:text-primary-700 hover:underline"
                          >
                            {selectedLocation.address}
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                  <div>
                    <p className="font-semibold">Phone:</p>
                    <ul className="list-disc pl-5">
                      <li>{selectedLocation.phone}</li>
                    </ul>
                  </div>
                  {selectedLocation.fax && (
                    <div>
                      <p className="font-semibold">Fax:</p>
                      <ul className="list-disc pl-5">
                        <li>{selectedLocation.fax}</li>
                      </ul>
                    </div>
                  )}
                  <div>
                    <p className="font-semibold">Hours:</p>
                    <ul className="list-disc pl-5">
                      {selectedLocation.hours.split('\n').map((hour, index) => (
                        <li key={index}>{hour}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Services</h3>
                <ul className="list-disc pl-5 text-gray-600">
                  {selectedLocation.services.split(', ').map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
              </div>

              {selectedLocation.doctors.length > 0 && (
                <div>
                  {/* Group providers by Medical and Therapy */}
                  <h3 className="font-semibold text-gray-900 mb-2">Our Providers</h3>
                  {/* Medical Providers */}
                  {selectedLocation.doctors.filter(doc => /PA-C|PA|PMHNP/.test(doc.name)).length > 0 && (
                    <div className="mb-4">
                      <h4 className="font-semibold text-primary-600 mb-2">Medical Providers</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {selectedLocation.doctors.filter(doc => /PA-C|PA|PMHNP/.test(doc.name)).map((doctor, index) => (
                          <div key={index} className="bg-gray-50 p-4 rounded-lg">
                            <p className="font-semibold text-primary-600">{doctor.name}</p>
                            <p className="text-gray-600">{doctor.specialty}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* Therapy Providers */}
                  {selectedLocation.doctors.filter(doc => !/PA-C|PA|PMHNP/.test(doc.name)).length > 0 && (
                    <div>
                      <h4 className="font-semibold text-primary-600 mb-2">Therapy Providers</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {selectedLocation.doctors.filter(doc => !/PA-C|PA|PMHNP/.test(doc.name)).map((doctor, index) => (
                          <div key={index} className="bg-gray-50 p-4 rounded-lg">
                            <p className="font-semibold text-primary-600">{doctor.name}</p>
                            <p className="text-gray-600">{doctor.specialty}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Locations;
